/* eslint-disable camelcase */
/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
import AbstractLayerTreeElement from '@/models/map-context/AbstractLayerTreeElement';
import AuthenticationInfos from '@/models/map-context/AuthenticationInfos';
import { pluginServiceInstance, PluginService } from '@/services/PluginService';
import MapContext from '@/models/map-context/MapContext';
import Plugin from '@/models/plugin/Plugin';
import axios, { AxiosResponse } from 'axios';
import Application from '@/models/map-context/Application';
import { BIconFileEarmarkPerson } from 'bootstrap-vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import ColorPalette, { IColorPalette } from '@/models/ColorPalette';
import { Observable } from 'rxjs';
import AdministrativeArea from '@/models/shared/AdministrativeArea';
import DownloadProjection from '@/models/shared/DownloadProjection';
import { EventBus, EVENTS } from './EventBus';
import Configuration from '@/models/Configuration';
import Internationalization from '@/models/Internationalization';
import AlertMessage from '@/models/shared/AlertMessage';

class ContextService {

  currentContext: MapContext |null= null;

  is3d=false;

  defaultlang='fr';

  i18n=new Internationalization();

  currentApplication: Application |null= null;

  localContext: MapContext |null= null;

  localApplication: Application |null= null;

  currentActionTarget!: any;

  currentAction='';

  termsValidationRequired = false;

  isEditionActive = false;

  contentEditionIsAllowed = true;

  configLoaded = false;

  showHeader = true;

  customHeaderAndFooter = false; // intégration d'un header et d'un footer personnalisé

  simpleHeader = false; // header simplifié pour les applis qui ont déjà leur propre header

  showFooter = true;

  showModalFooter =true; // false pour cacher les boutons d'actions pendant l'édition du style 

  tablelayer:LayerConfig|null = null; // couche actuelle affichée dans le composant FeatureListPanel

  loading = false; // gère l'affichage de la fenetre de chargement

  user:any = null;
  // user:any = { email: 'dds', is_superuser: true, groups:[{ id: 1 }],usergroup_roles: [{ usergroup: { id: 1 } }] };//= null;

  private draggingLayer: AbstractLayerTreeElement | null=null;

  configuration!:Configuration;

  svgPictos!:any;

  colorPalettes:ColorPalette[]=[];

  private localStorageAuthDB:any = {};

  administrativeAreas:AdministrativeArea[] =[];

  downloadProjection:DownloadProjection[] =[];

  modalPositions:any = {};

  clipboard:any=null;

  constructor() {
  }

  init(loadConfigFromUrl=true){
    const localInfos = localStorage.getItem('localStorageAuthDB');

    if (localInfos !== undefined && localInfos !== null) {
      this.localStorageAuthDB = JSON.parse(localInfos);
    }

    const clipboard = localStorage.getItem('maps_clipboard');

    if (clipboard !== undefined && clipboard !== null) {
      this.clipboard = JSON.parse(clipboard);
    }

    if(loadConfigFromUrl){
      this.loadConfig().then((result) => {
        console.log('config loaded');
        this.configLoaded = true;
        this.configuration = new Configuration(result.data);

        this.onConfigLoaded();
        EventBus.$emit(EVENTS.CONFIG_LOADED, this.configuration);
        this.loadUserStatus();
      });
    }



  }
  
  getText(key:string){
    if(this.configLoaded){
      return this.i18n.getText(this.configuration.lang,key);
    }
    else{
      return this.i18n.getText(this.defaultlang,key);
    }


    
  }

  checkOrganization() {
    const hasOrganization = this.user?.usergroup_roles?.length > 0;
    if (!hasOrganization) {
      EventBus.$emit(
        EVENTS.ERROR,
        'Votre compte doit être attaché à une organisation pour créer une carte'
      );
      return false;
    }
    return true;
  }

  checkAndSaveContext(router:any) {
    if (!this.checkOrganization()) {
      return;
    }
    const reload =
      this.currentApplication &&
      this.currentApplication.id === undefined;
    if (
      reload &&
      this.currentApplication &&
      this.currentApplication.display_name === 'Mon appli'
    ) {
      EventBus.$emit(EVENTS.ERROR, 'Il est nécessaire de modifier le titre par defaut');
      EventBus.$emit(EVENTS.OPEN_LEFT_SIDE_MENU, 'SettingsPanel');
      return;
    }
    this.saveContext().then((app: Application) => {
      if (reload) {
        router.push({ path: `/map/${app.id}` });
      }
    });
  }

  loadPalettes(data:any){
    console.log('palettes loaded');
    this.colorPalettes = data.palettes.map((x:IColorPalette) => new ColorPalette(x));
  }
  addToClipBoad(obj:any){
    this.clipboard=obj;
    //put in local storage
    localStorage.setItem('maps_clipboard', JSON.stringify(obj));
  }

  clearClipBoad(){
    this.clipboard=null;
    localStorage.removeItem('maps_clipboard');
  }

  onConfigLoaded() {

    this.loadSvgPictos().then((result) => {
      console.log('pictos loaded');
      this.svgPictos = result.data;
    });
    this.loadPaletteList().then((result) => {
      this.loadPalettes(result.data);
    });

    this.administrativeAreas = this.configuration.administrativeAreas;


    this.downloadProjection = this.configuration.downloadProjections;

    if (this.configuration.header && this.configuration.header.show !== undefined) {
      this.showHeader = this.configuration.header.show;
    }
    if (this.configuration.header && this.configuration.header.simple !== undefined) {
      this.simpleHeader = this.configuration.header.simple;
    }
    if (this.configuration.footer && this.configuration.footer.show !== undefined) {
      this.showFooter = this.configuration.footer.show;
    }
    if (this.configuration.customHeaderAndFooter && this.configuration.customHeaderAndFooter.show === true) {
      this.customHeaderAndFooter = true;
      const headElement = document.getElementsByTagName('head')[0];
      let s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = this.configuration.customHeaderAndFooter.header_url;
      headElement.append(s);
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = this.configuration.customHeaderAndFooter.footer_url;
      headElement.append(s);
    }
  }

  createMap():void {
    // delete old map
    this.currentContext = null;
    let mapQuery=this.getApp('empty_template.json');
    let sample=true;
    if (this.configuration.new_map_defaults && this.configuration.new_map_defaults.id && this.configuration.new_map_defaults.id !== "") {
      let templateMapId = this.configuration.new_map_defaults.id ;
      mapQuery=this.getMapById(templateMapId);
      sample=false;
    }

    mapQuery.then((reponse:any) => {
      console.log(reponse.data);
      let retour = reponse.data;
      if(!sample){
        retour=retour.config;
      }
      let public_access = false;

      let highlight = false;
      if (this.configuration.new_map_defaults && this.configuration.new_map_defaults.public !== undefined) {
        public_access = this.configuration.new_map_defaults.public;
      }
      if (this.configuration.new_map_defaults && this.configuration.new_map_defaults.highlight !== undefined) {
        highlight = this.configuration.new_map_defaults.highlight;
      }
      const newApp = new Application({
        display_name: 'Mon appli',
        public_access,
        highlight,
      });
      const currentAppConfig = new MapContext(retour);
      this.loadContext(newApp, currentAppConfig);
      EventBus.$emit(EVENTS.OPEN_LEFT_SIDE_MENU, 'SettingsPanel');
    });
  }

  getBookmark(): any{
    return this.currentContext?.bookmarks
  }

  addBookmark(bookmark:any): void{
    this.currentContext?.bookmarks.push(bookmark)
  }

  removeBookmark(index: number) {
      this.currentContext?.bookmarks.splice(index, 1);
  }

  storePosition(id: string, position: number[]) {
    this.modalPositions[id]=position;
  }

  getPosition(id: string) {
    return this.modalPositions[id];
  }

  getDraggingLayer(): AbstractLayerTreeElement | null{
    return this.draggingLayer;
  }

  setDraggingLayer(layer:AbstractLayerTreeElement | null) :void {
    console.log('set dragging layer', layer);
    this.draggingLayer = layer;
  }

  loadContext(application:Application, appConfig: MapContext): void {
    this.currentApplication = application;
    this.currentContext = appConfig;
  }

  startEdition() :void{
    this.isEditionActive = true;
  }

  cancelEdition() :void{
    this.isEditionActive = false;
  }

  getCurrentApplication(): Application {
    if (this.currentApplication == null) {
      throw new Error('Application not loaded!');
    }
    return this.currentApplication;
  }

  getCurrentContext(): MapContext {
    if (this.currentContext == null) {
      throw new Error('Context not loaded!');
    }
    return this.currentContext;
  }
  getListGroup(){
    let url = `${this.getBaseApiUrl()}usergroup/user-groups/`;
    return axios.get(url);
  }

  getMapAccess(idMap: number){
    let url = `${this.getBaseApiUrl()}maps/maps/${idMap}/access`;
    return axios.get(url);
  }

  

  getCurrentApplicationMapAccess() {
    if (this.currentApplication == null) {
      return [];
    }

    if (this.currentApplication.map_access==undefined ||this.currentApplication.map_access.length === 0) {
      return [];
    }

    return this.currentApplication.map_access;
  }

  hasUserEditAccess():boolean {
    const lstMapAccess = this.getCurrentApplicationMapAccess();
    if (lstMapAccess.length === 0) {
      return false;
    }
    const currentUser = this.user;
    const match = lstMapAccess.filter((x:any) => x.access_type === 'write'
      && currentUser.groups && currentUser.groups.find((grp:any)=> grp.id === x.groupId));
    if (match.length > 0) {
      return true;
    }
    return false;
  }
  setBaseLayers(baseLayers :any): void {
    if (this.currentContext?.baseLayers == null) {
      throw new Error('Context not loaded!');
    }
    this.currentContext.baseLayers = baseLayers;
  }

  isContextLoaded(): boolean {
    return this.currentContext !== null;
  }

  setCurrentAction(action: string, target: any): void {
    this.currentActionTarget = target;
    this.currentAction = action;
  }

  getCsrfToken():string {
    const csrfToken:any = ((name) => {
      const re = new RegExp(`${name}=([^;]+)`);
      const value = re.exec(document.cookie);
      return (value != null) ? unescape(value[1]) : null;
    })('csrftoken');
    return csrfToken;
  }

  removeApp(map: Application):Promise<any> {
    return axios.delete(`${this.getMapsApiUrl()}/${map.id}/`, { headers: { 'X-CSRFToken': this.getCsrfToken() } }).then((result) => {
      console.log(result);
    });
  }

  deleteCurrentMap():Promise<any> {
    if (this.currentApplication !== null) {
      return this.removeApp(this.currentApplication);
    }
    throw new Error('Aucune application');
  }

  getJsonContext():any {
    if (this.currentContext !== null) {
      const mapContext = this.currentContext.toJson();
      pluginServiceInstance.plugins
        .forEach((plugin:Plugin) => mapContext.plugins.push(plugin.toJson()));
      return mapContext;
    }
    throw new Error('currentContext is null');
  }
  setAccessList(access:any):any {
    if (this.currentApplication !== null) {
      this.currentApplication.access = access;
    }
    throw new Error('currentApplication is null');
  }

  saveContext():Promise<any> {
    const promise = new Promise((resolve, reject) => {
      if (this.currentContext !== null) {
        let  mapContext;
        try {
          mapContext = this.getJsonContext();
        } catch (error:any) {
          console.log(error)
          if(error.message=="TooMuchDatas"){
            const message = 'Une couche GeoJson contient trop de données pour être sauvegardée, veuillez modifier vos couches pour pouvoir sauvegarder';
            EventBus.$emit(EVENTS.WARNING, new AlertMessage({ label: message, type: 'warning', autoHide: true }));
          }else{
            const message = 'Une erreur inattendue est survenue dans la sauvegarde de la carte';
            EventBus.$emit(EVENTS.WARNING, new AlertMessage({ label: message, type: 'warning', autoHide: true }));
          }

          reject();
          return
        }
        

        if (this.currentApplication !== null) {
          this.currentApplication.config = mapContext;// JSON.stringify(mapContext);
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const self = this;
          const csrfToken = this.getCsrfToken();

          let request;

          if (this.currentApplication.id !== undefined) {
            request = axios.put(`${this.getMapsApiUrl()}/${this.currentApplication.id}/`,
              this.currentApplication,
              { headers: { 'X-CSRFToken': csrfToken } });
          } else {
            request = axios.post(`${this.getMapsApiUrl()}/`,
              this.currentApplication,
              { headers: { 'X-CSRFToken': csrfToken } });
          }
          this.loading = true;
          EventBus.$emit(EVENTS.INFO, 'Sauvegarde en cours....');
          self.isEditionActive = false;
          request.then((res) => {
            console.log(res);
            self.loading = false;
            EventBus.$emit(EVENTS.INFO, 'Sauvegarde effectuée');
            // eslint-disable-next-line prefer-destructuring
            const id = res.data.id;
            self.getCurrentApplication().id = id;
            let thumb:any = self.currentApplication!.thumbnail;
            if (thumb != null && (thumb instanceof File || thumb instanceof Blob)) {
              const file:any = thumb;
              const formData = new FormData();
              formData.append('file', file);
              const config = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'X-CSRFToken': csrfToken,
                },
              };
              axios.put(`${this.getMapsApiUrl()}/${id}/thumbnail/`, formData, config).then((response) => {
                console.log(response);
                resolve(self.getCurrentApplication());
              });
            } else {
              resolve(self.getCurrentApplication());
            }
          }, (res) => {
            console.log(res);
            self.loading = false;
            self.isEditionActive = true;
            if (res.response.data && res.response.data.config) {
              EventBus.$emit(EVENTS.ERROR, res.response.data.config[0]);
            } else if (res.response.data && res.response.data.error) {
              EventBus.$emit(EVENTS.ERROR, res.response.data.error);
            } else {
              EventBus.$emit(EVENTS.ERROR, res);
            }
          });
        }
      }
    });
    return promise;
  }

  loadConfig():Promise<AxiosResponse<any>> {
    const url = './sample_data/config.json';
    return axios.get(url);
  }

  loadSvgPictos():Promise<AxiosResponse<any>> {
    return axios.get(this.configuration.static_base_url+'/styles/svg_icons.json');
  }

  loadUserStatus(): void {
    const url = `${this.getBaseApiUrl()}login/session/`;
    axios.get(url).then((result:any) => {
      console.log(result);
      if (result.data.authenticated) {
        this.user = result.data.user;
      } else {
        this.user = null;
      }
    }).catch((error) => {
      console.log(error.response);
      if (error.response.status === 403 && error.response.data.code === 'terms-required') {
        this.termsValidationRequired = true;
      }
    });
  }

  logout() :void{
    const url = `${this.getBaseApiUrl()}login/signout/`;
    axios.get(url).then((result) => {
      this.user = null;
    });
  }

  isDatavizEnabled():boolean {
    return this.configuration.dataviz && this.configuration.dataviz.active;
  }

  isComplexStyleEnabled():boolean {
    return this.configuration.complexStyling && this.configuration.complexStyling.active;
  }

  getBaseApiUrl():string {
    return this.configuration.base_api_url;
  }

  getAdministrativeAreas():AdministrativeArea[] {
    return this.administrativeAreas;
  }

  getDownloadProjections():DownloadProjection[] {
    return this.downloadProjection;
  }

  getCorsProxyUrl():string {
    return this.configuration.cors_proxy_url;
  }

  getMapsApiUrl():string {
    return this.configuration.maps_api_url;
  }

  getExplorerUrl():string {
    if (this.configuration.explorer_url) {
      return this.configuration.explorer_url;
    }
    return '/portail';
  }

  getHomeUrl():string {
    if (this.configuration.home_url) {
      return this.configuration.home_url;
    }
    return '#';
  }

  getPublishUrl():string {
    if (this.configuration.publish_url) {
      return this.configuration.publish_url;
    }
    return '/onegeo-publish';
  }

  getOneGeoLoginUrl():string {
    if (this.configuration.login_url) {
      return this.configuration.login_url;
    }
    return '/onegeo-login';
  }

  getMapById(id:number):Promise<AxiosResponse<any>> {
    return axios.get(`${this.getMapsApiUrl()}/${id}/`);
  }

  getMaps(query = '', keywordFilter:string|undefined, pageNumber = 1,
    pageSize = 3, ordering = 'id', controller?:AbortController):Promise<AxiosResponse<any>> {
    let url = `${this.getMapsApiUrl()}/?format=json&q=${query}&highlight=true&page=${pageNumber}&page_size=${pageSize}&ordering=${ordering}`;
    if (keywordFilter) {
      url += `&tags=${keywordFilter}`;
    }
    const params:any = {};
    if (controller) {
      params.signal = controller.signal;
    }
    return axios.get(url, params);
  }

  getThumbnailUrl(map: Application): string {
    if (map.thumbnail != null) {
      return `${this.getMapsApiUrl()}/${map.id}/thumbnail/`;
    }
    throw new Error('thumbnail is null');
  }

  getProxyFiedUrl(url: string):string {
    // return `${this.getBaseApiUrl()}/proxy?url=${encodeURIComponent(url)}`;
    return `${this.getCorsProxyUrl()}${url}`;
  }

  loadOGCServerList():Promise<AxiosResponse<any>> {
    const url = './sample_data/serverList.json';
    return axios.get(url);
  }

  loadPaletteList():Promise<AxiosResponse<any>> {
    const url = this.configuration.static_base_url+'/sample_data/color_palettes.json';
    return axios.get(url);
  }

  getApp(appId: number | string) :Promise<AxiosResponse<any>> {
    const url = `./sample_data/${appId}`;
    return axios.get(url);
  }

  loadUrl(url: string) :Promise<AxiosResponse<any>> {
    return axios.get(url);
  }

  isSuperUser() :boolean {
    return this.user && this.user.is_superuser;
  }

  removeAuthInfo(key: string) :void {
    delete this.localStorageAuthDB[key];
    localStorage.setItem('localStorageAuthDB', JSON.stringify(this.localStorageAuthDB));
  }

  addAuthInfo(key: string, authenticationInfos: AuthenticationInfos) :void {
    this.localStorageAuthDB[key] = authenticationInfos;
    localStorage.setItem('localStorageAuthDB', JSON.stringify(this.localStorageAuthDB));
  }

  getAuthInfos() :any {
    return this.localStorageAuthDB;
  }

  getHeaderHeight() {
    if (this.configuration.customHeaderAndFooter && this.configuration.customHeaderAndFooter.header_height) {
      return `min-height:${this.configuration.customHeaderAndFooter.header_height}px`;
    }
    return '';
  }

  getFooterHeight(){
    if (this.configuration.customHeaderAndFooter && this.configuration.customHeaderAndFooter.footer_height) {
      return `min-height:${this.configuration.customHeaderAndFooter.footer_height}px`;
    }
    return '';
  }

  getFooterSrc(){
    if (this.configuration.customHeaderAndFooter && this.configuration.customHeaderAndFooter.footer_src) {
      return this.configuration.customHeaderAndFooter.footer_src;
    }
    return '/portal/footer-light';
  }

  isGeoserverApiUrlDefined(){
    return this.configuration.geoserver_api_url && this.configuration.geoserver_api_url.length>0;
  }

  sendSld(layer: LayerConfig, styleName: string):Promise<AxiosResponse<any>> {
    console.log(layer.styletoSld());
    console.log(styleName);
    let geoserverAdminUrl=this.configuration.geoserver_api_url;

    const config = {
      headers: {
        'Content-Type': 'application/vnd.ogc.sld+xml',
        'Authorization': layer.authenticationInfos.getBasicAutorisationValue()

      },
    };
    let postUrl=`${geoserverAdminUrl}rest/workspaces/${layer.targetPrefix}/styles?name=${styleName}`;
    return axios.post(postUrl,layer.styletoSld(),config);
  }
  assignSld(layer: LayerConfig, styleName: string,defaultStyle:boolean):Promise<AxiosResponse<any>> {
    console.log(layer.styletoSld());
    console.log(styleName);
    let geoserverAdminUrl=this.configuration.geoserver_api_url;

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': layer.authenticationInfos.getBasicAutorisationValue()
      },
    };
    let data={
        style:{
          "name": styleName
        }
    };
    let postUrl=`${geoserverAdminUrl}rest/layers/${layer.layername}/styles?default=${defaultStyle}`;
    return axios.post(postUrl,data,config);
  }
  getJsonMapLibre() {
    if (this.currentContext !== null) {
        const style = this.currentContext.toMapLibre();
        return {
            ...style,
            name: this.currentApplication?.display_name ?? "",
            id: this.currentApplication?.id ?? "",
        };
      }
      throw new Error('currentContext is null');
  }
}
const contexteServiceInstance = new ContextService();
export default ContextService;
export { ContextService, contexteServiceInstance };
